var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { getPaymentSchemeDetails, getPaymentSchemes } from '../../Async/PaymentSchemeAsync';
import { StyledSelect } from '../../Components/StyledSelect';
import { MedicationStatus, MedicationType, PaymentSchemeType, PbsRestrictionType, PoisonScheduleStatus } from '../../Contracts/MedicationModels';
import { CancelledRequest, useHttpConfig } from '../../Shared/HttpRequestExecutor';
import { EditMedicationSection } from './EditMedicationSection';
import { PaymentSchemeDetailsSection } from '../PaymentScheme/PaymentSchemeDetailsSection';
import { EditMedicationPaymentAuthorityDetails } from './EditMedicationPaymentAuthorityDetails';
import { useField } from '../../Components/useForm/useField';
import { LoadingPlaceholder } from '../../Components/Placeholder';
import { LayoutCentral } from '../../Components/LayoutCentral';
var DefaultSnapshot = {
    paymentSchemeCode: '',
    paymentSchemeName: '',
    programCode: '',
    programName: '',
    restrictionType: PbsRestrictionType.Unrestricted,
    indicationCode: '',
    indicationName: '',
    indicationDisplayCode: '',
    indicationTreatmentPhase: '',
    manufacturerCode: '',
    maxNumberOfPacks: 1,
    maxNumberOfRepeats: 0,
    maxQuantityPerPack: 0
};
var usePaymentStyles = makeStyles({
    container: {
        width: 415
    },
    loadingContainer: {
        height: 300
    }
});
/**
 * Need approval number if
 * if (Current snapshot.PbsRestrctionType == AuthorityRequired)
 * else if (packAmount > maxPacks || repeatAmount > maxRepeats)
 */
export function doesPaymentSchemeNeedApprovalNumber(medicationType, restrictionType, numOfPacks, maxNumPacks, repeats, maxRepeats) {
    var packsAreDifferent;
    if (medicationType === MedicationType.TakeHomeScript) {
        packsAreDifferent = numOfPacks > maxNumPacks || repeats > maxRepeats;
    }
    else {
        packsAreDifferent = numOfPacks > maxNumPacks;
    }
    if (restrictionType === PbsRestrictionType.AuthorityRequired)
        return true;
    if (packsAreDifferent)
        return true;
    return false;
}
var PRIVATE_PAYMENT_SCHEME_CODE = 'PRIVATE';
var paymentSchemeToString = function (it) {
    var _a;
    var paymentSchemeName = it.paymentSchemeName;
    if (((_a = it.paymentDetail) === null || _a === void 0 ? void 0 : _a.prescriberGroups.length) > 0)
        paymentSchemeName += " - (" + it.paymentDetail.prescriberGroups
            .map(function (it) { var _a; return (_a = it.displayShortName) !== null && _a !== void 0 ? _a : it.code; })
            .join(', ') + ")";
    return paymentSchemeName;
};
export var EditMedicationPaymentDetails = React.forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var _6 = __read(useState(false), 2), componentLoaded = _6[0], setComponentLoaded = _6[1];
    var paymentStyles = usePaymentStyles();
    var _7 = __read(useState(null), 2), paymentSchemeDetails = _7[0], setPaymentSchemeDetails = _7[1];
    var patientMedication = props.patientMedication;
    var pbsPrescriberGroupCode = (_d = (_c = (_b = (_a = props.currentProvider) === null || _a === void 0 ? void 0 : _a.prescriberDetails) === null || _b === void 0 ? void 0 : _b.pbsPrescriberGroup) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : '';
    var httpPaymentDetailsConfig = useHttpConfig();
    var formPaymentSnapshot = useField({ form: props.form, field: 'snapshot' });
    var formPaymentType = useField({ form: props.form, field: 'scheme' });
    var _8 = __read(useState(formPaymentSnapshot.value ? __assign({}, formPaymentSnapshot.value) : null), 2), lastSnapShot = _8[0], setLastSnapShot = _8[1];
    var _9 = __read(useState(false), 2), loadingDetails = _9[0], setLoadingDetails = _9[1];
    var _10 = __read(useState(false), 2), loadingPaymentAuthorityDetails = _10[0], setLoadingPaymentAuthorityDetails = _10[1];
    function updateSnapShot(snapShot) {
        formPaymentSnapshot.setValue(snapShot);
        setLastSnapShot(__assign({}, snapShot));
    }
    var numberOfPacksField = useField({ form: props.form, field: 'numberOfPacks' });
    var repeatsField = useField({ form: props.form, field: 'repeats' });
    var medicationTypeField = useField({ form: props.form, field: 'medicationType' });
    var maximumSupplyPermittedField = useField({ form: props.form, field: 'maximumSupplyPermitted' });
    var paymentDetailApprovalNumberField = useField({ form: props.form, field: 'paymentDetailApprovalNumber' });
    var medicationField = useField({ form: props.form, field: 'medication' });
    var currentNumOfPacks = !isNaN(Number(numberOfPacksField.value)) ? Number(numberOfPacksField.value) : 0;
    var currentRepeats = !isNaN(Number(repeatsField.value)) ? Number(repeatsField.value) : 0;
    var currentMaxPacks = (_f = (_e = formPaymentSnapshot.value) === null || _e === void 0 ? void 0 : _e.maxNumberOfPacks) !== null && _f !== void 0 ? _f : 0;
    var currentMaxRepeats = (_h = (_g = formPaymentSnapshot.value) === null || _g === void 0 ? void 0 : _g.maxNumberOfRepeats) !== null && _h !== void 0 ? _h : 0;
    var currentRestrictionType = (_j = formPaymentSnapshot.value) === null || _j === void 0 ? void 0 : _j.restrictionType;
    var currentMedicationType = (_k = medicationTypeField.value) !== null && _k !== void 0 ? _k : { value: MedicationType.TakeHomeScript };
    var currentMaximumSupplyPermitted = (_l = maximumSupplyPermittedField.value) !== null && _l !== void 0 ? _l : '';
    function updateApprovalNumber(medicationType, restrictionType, numOfPacks, maxNumPacks, repeats, maxRepeats, approvalNumber) {
        var needsApprovalNumber = doesPaymentSchemeNeedApprovalNumber(medicationType, restrictionType, numOfPacks, maxNumPacks, repeats, maxRepeats);
        if (restrictionType === PbsRestrictionType.AuthorityRequiredStreamlined && !needsApprovalNumber) {
            paymentDetailApprovalNumberField.setValue(approvalNumber !== null && approvalNumber !== void 0 ? approvalNumber : '');
        }
        else {
            paymentDetailApprovalNumberField.setValue('');
        }
    }
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (componentLoaded && patientMedication.status === MedicationStatus.Draft) {
            var numOfPacks = !isNaN(Number(numberOfPacksField.value)) ? Number(numberOfPacksField.value) : 0;
            var repeats = !isNaN(Number(repeatsField.value)) ? Number(repeatsField.value) : 0;
            updateApprovalNumber(currentMedicationType.value, (_b = (_a = formPaymentSnapshot.value) === null || _a === void 0 ? void 0 : _a.restrictionType) !== null && _b !== void 0 ? _b : PbsRestrictionType.Unrestricted, numOfPacks, (_d = (_c = formPaymentSnapshot.value) === null || _c === void 0 ? void 0 : _c.maxNumberOfPacks) !== null && _d !== void 0 ? _d : 0, repeats, (_f = (_e = formPaymentSnapshot.value) === null || _e === void 0 ? void 0 : _e.maxNumberOfRepeats) !== null && _f !== void 0 ? _f : 0, (_g = formPaymentSnapshot.value) === null || _g === void 0 ? void 0 : _g.indicationDisplayCode);
        }
    }, [numberOfPacksField.value, repeatsField.value]);
    // When a indication is chosen (changePBSDetails in story)
    // 1. Update current repeats/packs if they are not different to last chosen values defaults
    // 2. Set the max repeats/packs for UI
    // 3. Update snapshot value on form to include all new data.
    var selectPaymentSchemeDetail = function (paymentSchemeDetails, indication, snapshot) {
        var newSnapShot = __assign(__assign(__assign(__assign({}, DefaultSnapshot), formPaymentSnapshot.value), snapshot), { indicationCode: indication.code, indicationDisplayCode: indication.displayCode, indicationName: indication.name, indicationTreatmentPhase: indication.treatmentPhase, maxNumberOfPacks: indication.maxNumberOfPacks, maxNumberOfRepeats: indication.maxNumberOfRepeats, maxQuantityPerPack: indication.maxQuantityPerPack, manufacturerCode: paymentSchemeDetails === null || paymentSchemeDetails === void 0 ? void 0 : paymentSchemeDetails.manufacturerCode });
        var restrictionType = newSnapShot.restrictionType;
        var numOfPacks = currentNumOfPacks;
        var repeats = currentRepeats;
        // If the last snapshot payment scheme code is the private key, then a value of 1 is the default and should be updated.
        var lastMaxPacksWasAutomaticForPrivateScheme = currentNumOfPacks === 1 && (lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.paymentSchemeCode) === PRIVATE_PAYMENT_SCHEME_CODE;
        var lastPaymentSchemeWasUnselected = currentNumOfPacks === 1 && !(lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.paymentSchemeCode);
        // If the user hasn't changed number of packs, set it to the recommended value.
        if (currentNumOfPacks === (lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.maxNumberOfPacks) ||
            currentNumOfPacks === 0 ||
            lastMaxPacksWasAutomaticForPrivateScheme ||
            lastPaymentSchemeWasUnselected ||
            (lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.maxNumberOfPacks) == 0) {
            // If the indication.maxNumberOfPacks is 1 or more use its value, otherwise use 1.
            numOfPacks = indication.maxNumberOfPacks ? indication.maxNumberOfPacks : 1;
            numberOfPacksField.setValue(numOfPacks.toString());
        }
        // If the user hasn't changed number of repeats, set it to the recommended value.
        if (currentRepeats === (lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.maxNumberOfRepeats) || currentRepeats === 0) {
            repeats = indication.maxNumberOfRepeats;
            repeatsField.setValue(indication.maxNumberOfRepeats.toString());
        }
        // This updates the UI to display the proper max information
        var maxMedsInfo = {
            maxRepeats: indication.maxNumberOfRepeats,
            maxPacks: indication.maxNumberOfPacks,
            maxPerPack: indication.maxQuantityPerPack
        };
        props.onChangeMaxMedsInfo(maxMedsInfo);
        if (patientMedication.status === MedicationStatus.Draft) {
            // This is to guarantee that set field is executed "after" all other react state changes have happened.
            setTimeout(function () {
                updateApprovalNumber(currentMedicationType.value, restrictionType, numOfPacks, indication.maxNumberOfPacks, repeats, indication.maxNumberOfRepeats, indication.displayCode);
            });
        }
        updateSnapShot(newSnapShot);
    };
    // When choosing a payment scheme
    // 1. Update snapshot with new values
    // 2. Request all payment scheme details from API
    // 3. Update displayed payment scheme details displayed
    // 4. Select first scheme detail (indication) as default
    var selectPaymentScheme = function (paymentScheme) { return __awaiter(void 0, void 0, void 0, function () {
        var snapShot, detailsFilter;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    setLoadingPaymentAuthorityDetails(true);
                    formPaymentType.setValue(paymentScheme.type);
                    if (!(paymentScheme.type === PaymentSchemeType.Pbs)) return [3 /*break*/, 2];
                    snapShot = __assign(__assign({}, DefaultSnapshot), { paymentSchemeCode: paymentScheme.paymentSchemeCode, paymentSchemeName: paymentScheme.paymentSchemeName, programCode: (_b = (_a = paymentScheme.paymentDetail) === null || _a === void 0 ? void 0 : _a.pbsProgram.code) !== null && _b !== void 0 ? _b : '', programName: (_d = (_c = paymentScheme.paymentDetail) === null || _c === void 0 ? void 0 : _c.pbsProgram.name) !== null && _d !== void 0 ? _d : '', restrictionType: (_f = (_e = paymentScheme.paymentDetail) === null || _e === void 0 ? void 0 : _e.pbsRestrictionType) !== null && _f !== void 0 ? _f : PbsRestrictionType.Unrestricted });
                    detailsFilter = {
                        pbsPrescriberGroupCode: pbsPrescriberGroupCode,
                        type: paymentScheme.type,
                        paymentDetail: {
                            pbsPaymentSchemeCode: (_g = snapShot.paymentSchemeCode) !== null && _g !== void 0 ? _g : '',
                            pbsProgramCode: (_h = snapShot.programCode) !== null && _h !== void 0 ? _h : '',
                            pbsRestrictionType: (_j = snapShot.restrictionType) !== null && _j !== void 0 ? _j : PbsRestrictionType.Unrestricted
                        }
                    };
                    if (currentMedicationType.value == MedicationType.EnrmcScript &&
                        paymentScheme.type === PaymentSchemeType.Pbs &&
                        paymentScheme.paymentDetail.pbsRestrictionType !== null &&
                        paymentScheme.paymentDetail.pbsRestrictionType !== PbsRestrictionType.AuthorityRequired &&
                        ((_k = patientMedication.medication) === null || _k === void 0 ? void 0 : _k.poisonSchedule.poisonScheduleStatus) === PoisonScheduleStatus.Alert &&
                        currentMaximumSupplyPermitted !== '1') {
                        maximumSupplyPermittedField.setValue('1');
                    }
                    if (((_l = patientMedication.medication) === null || _l === void 0 ? void 0 : _l.poisonSchedule.poisonScheduleStatus) !== PoisonScheduleStatus.Warning &&
                        ((_m = patientMedication.medication) === null || _m === void 0 ? void 0 : _m.poisonSchedule.poisonScheduleStatus) !== PoisonScheduleStatus.Alert &&
                        currentMaximumSupplyPermitted !== '') {
                        maximumSupplyPermittedField.setValue('');
                    }
                    updateSnapShot(snapShot);
                    return [4 /*yield*/, loadAndSetDetails(detailsFilter, snapShot)];
                case 1:
                    _o.sent();
                    return [3 /*break*/, 3];
                case 2:
                    // If the payment scheme type is not PBS, at the moment that means it's private.
                    setPaymentSchemeDetails(null);
                    updateSnapShot(__assign(__assign({}, DefaultSnapshot), { paymentSchemeCode: paymentScheme.paymentSchemeCode, paymentSchemeName: paymentScheme.paymentSchemeName }));
                    // Because we are setting payment details to not PBS, if the current number of packs is automatically set
                    // we can set it back to 1
                    if (currentNumOfPacks === (lastSnapShot === null || lastSnapShot === void 0 ? void 0 : lastSnapShot.maxNumberOfPacks) || currentNumOfPacks === 0) {
                        numberOfPacksField.setValue('1');
                        paymentDetailApprovalNumberField.setValue('');
                    }
                    else {
                        paymentDetailApprovalNumberField.setValue('');
                    }
                    props.onChangeMaxMedsInfo({
                        maxRepeats: 0,
                        maxPacks: 0,
                        maxPerPack: 0
                    });
                    _o.label = 3;
                case 3:
                    // This is to guarantee that set field is executed "after" all other react state changes have happened.
                    setTimeout(function () {
                        setLoadingPaymentAuthorityDetails(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var loadAndSetDetails = function (detailsFilter, snapshot) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentSchemeDetails_1, firstIndication, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!medicationField.value)
                        return [2 /*return*/];
                    setLoadingDetails(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getPaymentSchemeDetails(httpPaymentDetailsConfig, medicationField.value.code, detailsFilter)];
                case 2:
                    paymentSchemeDetails_1 = _a.sent();
                    if (paymentSchemeDetails_1 instanceof CancelledRequest) {
                        return [2 /*return*/];
                    }
                    if (paymentSchemeDetails_1) {
                        setPaymentSchemeDetails(paymentSchemeDetails_1);
                        if (paymentSchemeDetails_1.indications.length > 0) {
                            firstIndication = paymentSchemeDetails_1.indications[0];
                            if (snapshot && !snapshot.indicationCode) {
                                selectPaymentSchemeDetail(paymentSchemeDetails_1, firstIndication, snapshot);
                            }
                        }
                    }
                    else {
                        setPaymentSchemeDetails(null);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error('Unable to load initial indications');
                    return [3 /*break*/, 4];
                case 4:
                    setLoadingDetails(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Fetch these details on component load
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!props.readOnly) {
            if (!!formPaymentSnapshot && formPaymentType) {
                var detailsFilter = {
                    pbsPrescriberGroupCode: pbsPrescriberGroupCode,
                    type: (_a = formPaymentType.value) !== null && _a !== void 0 ? _a : PaymentSchemeType.Private,
                    paymentDetail: {
                        pbsPaymentSchemeCode: (_c = (_b = formPaymentSnapshot.value) === null || _b === void 0 ? void 0 : _b.paymentSchemeCode) !== null && _c !== void 0 ? _c : '',
                        pbsProgramCode: (_e = (_d = formPaymentSnapshot.value) === null || _d === void 0 ? void 0 : _d.programCode) !== null && _e !== void 0 ? _e : '',
                        pbsRestrictionType: (_g = (_f = formPaymentSnapshot.value) === null || _f === void 0 ? void 0 : _f.restrictionType) !== null && _g !== void 0 ? _g : PbsRestrictionType.Unrestricted
                    }
                };
                loadAndSetDetails(detailsFilter, formPaymentSnapshot.value);
            }
        }
        setComponentLoaded(true);
    }, []);
    // The chosen payment scheme is always derived from the snapshot
    var chosenPaymentScheme = null;
    if (!!formPaymentSnapshot && formPaymentType) {
        var pbsProgram = {
            code: (_o = (_m = formPaymentSnapshot.value) === null || _m === void 0 ? void 0 : _m.programCode) !== null && _o !== void 0 ? _o : '',
            name: (_q = (_p = formPaymentSnapshot.value) === null || _p === void 0 ? void 0 : _p.programName) !== null && _q !== void 0 ? _q : ''
        };
        chosenPaymentScheme = {
            paymentDetail: {
                pbsProgram: pbsProgram,
                pbsRestrictionType: (_s = (_r = formPaymentSnapshot.value) === null || _r === void 0 ? void 0 : _r.restrictionType) !== null && _s !== void 0 ? _s : PbsRestrictionType.Unrestricted,
                prescriberGroups: []
            },
            paymentSchemeName: (_u = (_t = formPaymentSnapshot.value) === null || _t === void 0 ? void 0 : _t.paymentSchemeName) !== null && _u !== void 0 ? _u : '',
            paymentSchemeCode: (_w = (_v = formPaymentSnapshot.value) === null || _v === void 0 ? void 0 : _v.paymentSchemeCode) !== null && _w !== void 0 ? _w : '',
            type: (_x = formPaymentType.value) !== null && _x !== void 0 ? _x : PaymentSchemeType.Private,
            pbsRestrictionType: (_z = (_y = formPaymentSnapshot.value) === null || _y === void 0 ? void 0 : _y.restrictionType) !== null && _z !== void 0 ? _z : PbsRestrictionType.Unrestricted,
            pbsProgram: pbsProgram,
            orderNumber: 0
        };
    }
    var readOnlyPaymentDetails = null;
    if (!!formPaymentSnapshot && !!((_0 = formPaymentSnapshot.value) === null || _0 === void 0 ? void 0 : _0.indicationCode)) {
        readOnlyPaymentDetails = {
            notesHtmlText: '',
            indications: [
                {
                    code: formPaymentSnapshot.value.indicationCode,
                    displayCode: formPaymentSnapshot.value.indicationDisplayCode,
                    name: formPaymentSnapshot.value.indicationName,
                    maxNumberOfRepeats: formPaymentSnapshot.value.maxNumberOfRepeats,
                    maxNumberOfPacks: formPaymentSnapshot.value.maxNumberOfPacks,
                    maxQuantityPerPack: formPaymentSnapshot.value.maxQuantityPerPack,
                    indicationHtmlText: '',
                    approvedIndicationNumber: '',
                    prescriberGroups: [],
                    treatmentPhase: formPaymentSnapshot.value.indicationTreatmentPhase
                }
            ],
            cautionsHtmlText: '',
            manufacturerCode: ''
        };
    }
    return (React.createElement(EditMedicationSection, { index: props.index, border: props.border, error: props.error, ref: ref, showCtgAnnotation: true, title: 'Payment details', patientMedication: props.patientMedication, hideSection: props.hideSection, titleInput: React.createElement("div", { className: paymentStyles.container },
            React.createElement(StyledSelect, { value: chosenPaymentScheme, readOnly: props.readOnly, maxResults: 0, isClearable: false, isSearchable: false, label: 'Payment scheme', itemToString: paymentSchemeToString, itemToMenuKey: function (it) { return it.paymentSchemeCode; }, onSelection: selectPaymentScheme, fetch: function (config) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, medicationField.value && medicationField.value.code
                                ? getPaymentSchemes(config, medicationField.value.code, {
                                    pbsPrescriberGroupCode: pbsPrescriberGroupCode
                                })
                                : []];
                    });
                }); }, testId: 'selection-input-payment-scheme', wrapOptions: true, noWrapReadOnly: true, hideWarningEmptyHelperText: true })) }, loadingDetails || loadingPaymentAuthorityDetails ? (React.createElement("div", { style: { height: '150px' } },
        React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)))) : (React.createElement(React.Fragment, null,
        React.createElement(PaymentSchemeDetailsSection, { loading: loadingDetails, readOnly: props.readOnly, scheme: props.readOnly ? readOnlyPaymentDetails : paymentSchemeDetails, chosenIndicationCode: (_2 = (_1 = formPaymentSnapshot.value) === null || _1 === void 0 ? void 0 : _1.indicationCode) !== null && _2 !== void 0 ? _2 : '', onIndicationChosen: selectPaymentSchemeDetail }),
        formPaymentType.value !== PaymentSchemeType.Private && (React.createElement(EditMedicationPaymentAuthorityDetails, { form: props.form, schemeType: formPaymentType.value, readOnly: props.readOnly, prescriberNumber: (_5 = (_4 = (_3 = props.currentProvider) === null || _3 === void 0 ? void 0 : _3.prescriberDetails) === null || _4 === void 0 ? void 0 : _4.number) !== null && _5 !== void 0 ? _5 : '', needApprovalNumber: doesPaymentSchemeNeedApprovalNumber(currentMedicationType.value, currentRestrictionType !== null && currentRestrictionType !== void 0 ? currentRestrictionType : PbsRestrictionType.Unrestricted, currentNumOfPacks, currentMaxPacks, currentRepeats, currentMaxRepeats), restrictionType: currentRestrictionType }))))));
});
